@if (isSuccessfullySubmitted) {
  <div class="flex-centered spinner-container">
    <mat-spinner diameter="60"></mat-spinner>
  </div>
}

@if (incomeForm && !isSuccessfullySubmitted) {
  <form
    [formGroup]="incomeForm"
    (ngSubmit)="saveIncomeForm()"
    eevTrackFormStart
    [eevFormTrackingConfig]="incomeFormTrackingConfig"
    [eevTrackDistinctFieldErrors]="fieldErrors$"
    >
    <div (mouseleave)="setIsIndividualGrossAnnualIncomeGroupHovered(false)">
      <app-be-input-group-reactive
        [beFormGroup]="incomeForm"
        [beFormControl]="incomeForm.controls['individualGrossAnnualIncome']"
        beFormControlName="individualGrossAnnualIncome"
        inputName="annual-gross-income"
        inputLabel="Individual Gross Annual Income"
        requiredError="This field is required"
        maskValue="separator.0"
      [describedBy]="
        isIndividualGrossAnnualIncomeWarning &&
        (isIndividualGrossAnnualIncomeFocused ||
          (isIndividualGrossAnnualIncomeGroupHovered | async))
          ? 'individualGrossAnnualIncomeTips individualGrossAnnualIncomeNotification'
          : isIndividualGrossAnnualIncomeWarning
            ? 'individualGrossAnnualIncomeNotification'
            : isIndividualGrossAnnualIncomeFocused ||
                (isIndividualGrossAnnualIncomeGroupHovered | async)
              ? 'individualGrossAnnualIncomeTips'
              : null
      "
        describedBy="individualGrossAnnualIncomeTips individualGrossAnnualIncomeNotification"
        (onFocus)="setIsIndividualGrossAnnualIncomeFocused(true)"
        (onBlur)="setIsIndividualGrossAnnualIncomeFocused(false)"
      [eevTrackingConfig]="
        incomeFormTrackingConfig.fields[AuthFormFieldName.INDIVIDUAL_INCOME]
      "
        [errorTrackingSubject]="fieldErrors$"
        >
        <svg icon viewBox="0 0 100 100" class="be-input-icon be-input-icon--left">
          <use [attr.href]="'assets/icons-v2/sprites.svg#dollar-sign'"></use>
        </svg>
      </app-be-input-group-reactive>
      @if (
        isIndividualGrossAnnualIncomeFocused ||
        (isIndividualGrossAnnualIncomeGroupHovered | async)
        ) {
        <app-be-tooltip
          @fadeInOut
          (mouseenter)="setIsIndividualGrossAnnualIncomeGroupHovered(true)"
          id="individualGrossAnnualIncomeTips"
          >
          <p class="be-text-xs text-white">What to include:</p>
          <ul class="income-bullet-list">
            <li class="be-text-xs text-white">Wages or salary before taxes</li>
            <li class="be-text-xs text-white">Bonuses and commissions</li>
            <li class="be-text-xs text-white">Any other verifiable income</li>
          </ul>
          <p class="be-text-xs text-white">
            Be precise as we may require proof of income
          </p>
        </app-be-tooltip>
      }
    </div>
    @if (isIndividualGrossAnnualIncomeWarning) {
      <app-notification
        id="individualGrossAnnualIncomeNotification"
        variant="warning"
        >
        <p class="be-body-s text-navy-800">Are you sure?</p>
        <p class="be-body-s text-navy-800">
          You entered an <span class="be-body-s-bold">ANNUAL</span> income of
          <span class="be-body-s-bold"
            >${{
            incomeForm.controls['individualGrossAnnualIncome'].value | number
            }}</span
            >.
          </p>
        </app-notification>
      }
      <div (mouseleave)="setIsHouseholdIncomeGroupHovered(false)">
        <app-be-input-group-reactive
          [beFormGroup]="incomeForm"
          [beFormControl]="incomeForm.controls['householdIncome']"
          beFormControlName="householdIncome"
          inputName="household-income"
          inputLabel="Household Income"
      [describedBy]="
        isHouseholdIncomeFocused || (isHouseholdIncomeGroupHovered | async)
          ? 'householdIncomeTips householdIncomeNotification'
          : 'householdIncomeNotification'
      "
          requiredError="This field is required"
          maskValue="separator"
          (onFocus)="setIsHouseholdIncomeFocused(true)"
          (onBlur)="setIsHouseholdIncomeFocused(false)"
      [eevTrackingConfig]="
        incomeFormTrackingConfig.fields[AuthFormFieldName.HOUSEHOLD_INCOME]
      "
          [errorTrackingSubject]="fieldErrors$"
          >
          <svg icon viewBox="0 0 100 100" class="be-input-icon be-input-icon--left">
            <use [attr.href]="'assets/icons-v2/sprites.svg#dollar-sign'"></use>
          </svg>
        </app-be-input-group-reactive>
        @if (
          isHouseholdIncomeFocused || (isHouseholdIncomeGroupHovered | async)
          ) {
          <app-be-tooltip
            @fadeInOut
            (mouseenter)="setIsHouseholdIncomeGroupHovered(true)"
            id="householdIncomeTips"
            >
            <p class="be-text-xs text-white">What to include:</p>
            <ul class="income-bullet-list">
              <li class="be-text-xs text-white">
                The amount from “Individual Gross Annual Income” above
              </li>
              <li class="be-text-xs text-white">
                Plus income from individuals that contribute to your household
              </li>
            </ul>
          </app-be-tooltip>
        }
      </div>
      <app-notification id="householdIncomeNotification">
        <p class="be-body-s text-navy-800">
          Income from alimony, child support, and separate maintenance does not need
          to be disclosed. If you are under 21, include only your independent
          sources of income.
        </p>
      </app-notification>
      <app-be-select-reactive
        [beFormGroup]="incomeForm"
        [beFormControl]="incomeForm.controls['employmentStatus']"
        beFormControlName="employmentStatus"
        label="Employment Status"
        [options]="employmentStatusOptions"
        optionKey="label"
    [eevTrackingConfig]="
      incomeFormTrackingConfig.fields[AuthFormFieldName.EMPLOYMENT_STATUS]
    "
      ></app-be-select-reactive>
      <div class="be-section-mt--responsive be-btn-group be-btn-group--left">
        <app-be-button
          size="small"
          type="submit"
          id="saveGrossIncomeFormBtn"
          [eevTrackClick]="AuthLinkType.PROFILE_SAVE"
          >
          Save
        </app-be-button>
        @if (!isNullField) {
          <button
            (click)="onCancel.emit()"
            class="be-btn be-btn--small be-btn--alt-borderless"
            type="button"
            [eevTrackClick]="AuthLinkType.PROFILE_CANCEL_EDIT"
            >
            Cancel
          </button>
        }
      </div>
    </form>
  }
